import * as API from '../../utils/api'

export const init = function(configs) {
    const defautExpire = 0;
    let getters = {};
    let actions = {};
    let mutations = {};
    let state = {}

    for (let i in configs) {
        let config = configs[i];

        state[config.method] = {
            cacheTime: (+new Date()),
            data: config.defaultState
        };
        getters[config.method] = (state) => {
            let dataWarp = state[config.method];
            return dataWarp && dataWarp.data;
        };
        actions[config.method] = ({ commit }, opts) => {
            opts = opts || {};
            //如果存在url则请求服务器数据，否则，直接调用commit
            if(opts.url){
                config.url = opts.url;
            }
            if (!config.url) {
                commit(config.type, config.defaultState);
                return;
            }

            let expire = config.expire;

            if (isNaN(expire) || expire < 0) {
                expire = defautExpire;
            }
            if (opts.expire) {
                expire = opts.expire;
            }
            let dataWarp = state[config.method];
            let passedTime = (+new Date()) - dataWarp.cacheTime;

            if (passedTime < expire && (dataWarp.data != config.defaultState)) {
                commit(config.type, dataWarp.data);
            } else {
                let callback = opts.callback || function(rst) {
                        opts.always && opts.always();
                        let currUrl = encodeURIComponent( window.location.href );

                        //网关返回失败
                        if (rst.resultCode.toString() != "0") {
                            let errorMsg = rst.resultMsg;
                            //trigger wg error
                            if (opts.error) {
                                opts.error(errorMsg);
                            } else {
                                commit(config.type, config.defaultState);
                                window.vue && window.vue.$emit("gateWayError", rst);
                            }
                        }else {

                            let result = rst.resultData;

                            commit(config.type, result);
                            opts.successFn && opts.successFn(result);
                        }
                    };

                if(config.reqMethod && config.reqMethod.toLowerCase() == "post") {
                    API.postData({
                        url: config.url,
                        data: opts.data,
                        config: opts.config ? opts.config : null,
                    }, callback, function(msg) {
                        opts.always && opts.always();
                        if (opts.error) {
                            opts.error(msg);
                        } else {
                            commit(config.type, config.defaultState);
                            window.vue && window.vue.$emit("serverError", msg);
                        }
                    });
                }else {
                    API.getData({
                        url: config.url,
                        data: opts.data,
                        config: opts.config ? opts.config : null,
                    }, callback, function(msg) {
                        opts.always && opts.always();
                        if (opts.error) {
                            opts.error(msg);
                        } else {
                            commit(config.type, config.defaultState);
                            window.vue && window.vue.$emit("serverError", msg);
                        }
                    });
                }
            }
        };
        mutations[config.type] = (state, data) => {
            let dataWrap = state[config.method];
            //强制更新缓存时间，使其过期时间延长
            if (config.forceUpdate) {
                dataWrap.cacheTime = (+new Date());
            }

            dataWrap.data = data;
        };
    }

    return {
        state,
        getters,
        actions,
        mutations
    }
}



// WEBPACK FOOTER //
// ./src/store/modules/init.js